import SkeletonPublicationCard from "./SkeletonPublicationCard";
import { SectionTitleSkeleton } from "../ui/SectionTitle";

// The real "Curated for you" feed renders 5 SkeletonPublicationCards while
// loading (DiscoveryPage), so mirror that count.
const ROWS = 5;

/**
 * Loading silhouette for the Discovery "Curated for you" section: the
 * section-title badge over the divided list of publication cards, matching
 * DiscoveryPage's `divide-y ... *:py-4 [first pt-0]` list.
 */
export default function DiscoveryFeedSkeleton(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3 px-5">
      <SectionTitleSkeleton width={120} />
      <div className="flex flex-col divide-y divide-ds-slate-100 *:py-4 [&>*:first-child]:pt-0">
        {Array.from({ length: ROWS }).map((_, idx) => (
          <SkeletonPublicationCard showImage key={idx} showDescription />
        ))}
      </div>
    </div>
  );
}
